module.exports = __webpack_public_path__ + "img/arrow-white.32807864.svg";